<template>
    <div class="abbuchen">
        <router-view></router-view>

        <div class="abbuchen__card">
            <icon-button class="abbuchen__close" @click="abbuchenclose">
                close
            </icon-button>

            <div class="artnumholder">
                <div>{{artDetails.artnum}}</div>
                <div class="spacer"></div>
                <div v-if="artDetails.greater100 === 1" class="greendot"></div>
                <div v-if="artDetails.MHD === 1" class="MHD">MHD</div>
            </div>

            <div class="abbucheninfodiv">
                <div class="abbuchendetailtext">
                    bestand: {{artDetails.max}} <br>
                    stao: {{selectedStao}}

                    <text-field label="Anzahl"
                                class="abbuchen__input"
                                type="number"
                                v-model="form.amount"
                    />

                    <default-button @click="abbuchen(1)"
                                    :variations="['full-width']"
                    >
                        Abbuchen
                    </default-button>
                    <default-button @click="abbuchen(-1)"
                                    :variations="['full-width']"
                                    class="stornier-button"
                                    v-if="allowedToStornier()"
                    >
                        Stornieren
                    </default-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DefaultButton from '../common/default-button';
import TextField from '../common/text-field';
import IconButton from '../common/icon-button';

export default {
    components: { IconButton, DefaultButton, TextField },
    props: {
        artId: {
            type: String,
            default: '1'
        },
        stao: {
            type: String,
            default: '1'
        }
    },
    data() {
        return {
            form: {
                amount: 1
            }
        }
    },
    computed: {
        artDetails() {
            return this.$store.getters['fotodatenbank/artDetails'];
        },

        userLev() {
            return this.$store.getters['user/autLev'];
        },

        selectedStao() {

            let staolist = this.$store.getters['user/staos'];

            let staoName = 'none';

            for (let i = 0; i < staolist.length; i++) {
                if (staolist[i].id.toString() === this.stao){
                    staoName = staolist[i].name; 
                }

            }

            return staoName;
        }
    },
    watch: {
        artDetails() {
            this.nowTime = (new Date()).getTime();
        }
    },
    methods: {
        abbuchenclose() {
            this.$router.go(-1);
        },
        abbuchen(mult) {
            this.$store.dispatch('fotodatenbank/abbuchen', {
                id: this.artId,
                stao: this.stao,
                amount: this.form.amount,
                mult: mult
            });
        },
        allowedToStornier() {
            // function basically void since it always returns true.
            // kept here since it might one day be needed.
            if (this.userLev.indexOf(6) > -1) {
                
                return true;
            }

            if (this.userLev.indexOf(7) > -1) {

                return true;
            }

            if (this.artDetails.verbrauchsMat === 1 && this.userLev.indexOf(8) > -1) {

                return true;
            }

            return true;
        }
    },
    created() {
        this.$store.dispatch('fotodatenbank/openDetails', { id: this.artId, stao: this.stao });
        this.$store.dispatch('user/getStaos');

        console.log(this.artId);
    }
}
</script>

<style scoped lang="scss">
    .abbuchen {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999;
    }

    .abbuchen__card {
        position: relative;
        display: flex;
        flex-direction: column;
        max-width: 100%;
        max-height: 90vh;
        background-color: $color-white;
        box-shadow: 0 0 4rem $color-gray;
        padding-top: 4rem;
        padding-left: 1rem;
        padding-right: 1rem;
        padding-bottom: 1rem;
        overflow: auto;

        @include medium {
            padding-top: 1rem;
            width: 31rem;
        }

        @include extra-large {
            width: auto;
            max-width: 90%;
        }
    }

    .abbuchen__close {
        position: absolute;
        top: 1rem;
        right: 1rem;
    }

    .abbuchen__input {
        margin-top: 1rem;
        margin-bottom: 1rem;
    }

    .abbucheninfodiv {
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    .addinfotext {
        height: 9.5rem;
        width: 100%;
    }

    .abbuchenbutton {
        width: 100%;
        background-color: $color-green;
        color: $color-white;
        font-size: 1.5rem;
        height: 100px;
    }

    .stornier-button {
        margin-top: 1rem;
        background-color: $color-red;
    }

    .artnumholder {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 2rem;
    }

    .spacer {
        flex: 1;
    }

    .greendot {
        border-radius: 50%;
        background-color: $color-green;
        height: 2rem;
        width: 2rem;
    }

    .MHD {
        background-color: #cc6600;
        height: 2rem;
        font-size: 1rem;
        line-height: 2rem;
        padding-left: 0.125rem;
        padding-right: 0.125rem;
    }

    @include extra-large {
        .abbuchendetailtext {
            /* flex: 1; */
            max-width: 31rem;
            min-width: 31rem;
        }
    }
</style>
